import React from "react";
import CommonButton from "../CommonButton";

interface BundleCardProps {
    bundle: {
        id: number;
        name: string;
        bundlePrice: string;
        isActive: boolean;
        totalProducts: number;
    };
    index: number;
    onEdit: () => void;
  
    onToggleStatus: () => void;
}

const BundleCard: React.FC<BundleCardProps> = ({
    bundle,
    index,
    onEdit,
    onToggleStatus,
}) => {
    return (
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-3xs flex flex-col sm:flex-row sm:items-center justify-between gap-4 text-left">
            <div className="flex items-center gap-4 min-w-0 flex-1">
                {/* INDEX BADGE */}
                <div className="px-2.5 py-1 bg-logoHeading text-white text-xs font-bold rounded-lg shrink-0">
                    Bundle {index + 1}
                </div>

                {/* INFO */}
                <div className="min-w-0 space-y-0.5">
                    <h4 className="text-sm font-black text-slate-900 truncate">
                        {bundle.name}
                    </h4>
                    <p className="text-[11px] text-slate-400 font-semibold">
                        Contains: <span className="text-slate-700 font-bold">{bundle.totalProducts} Products</span>
                        <span className="mx-2">•</span>
                        Status: <span className={`font-bold ${bundle.isActive ? "text-emerald-600" : "text-slate-400"}`}>{bundle.isActive ? "Active" : "Paused"}</span>
                    </p>
                </div>
            </div>

            {/* PRICE & ACTIONS SECTION */}
            <div className="flex items-center gap-6 shrink-0 self-end sm:self-center border-t sm:border-t-0 pt-3 sm:pt-0 border-slate-100 w-full sm:w-auto justify-between sm:justify-end">
                <div className="text-left sm:text-right">
                    <p className="text-[10px] uppercase font-black tracking-wider text-gray-400">Bundle Price</p>
                    <p className="text-lg font-black text-mainBrandColor">
                        AED {bundle.bundlePrice}
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <CommonButton
                        onClick={onToggleStatus}
                        text={bundle.isActive ? "Pause" : "Activate"}
                        className={`border-none text-xs font-bold ${bundle.isActive ? "bg-amber-50 text-amber-600 hover:bg-amber-100" : "bg-emerald-50 text-emerald-600 hover:bg-emerald-100"}`}
                        
                    />
                    <CommonButton
                        onClick={onEdit}
                        text="Edit"
                        className="bg-blue-50 text-blue-600 hover:bg-blue-100 border-none text-xs font-bold"
                        
                    />
                    {/* <CommonButton
                        onClick={onDelete}
                        text="Delete"
                        className="bg-red-50 text-red-600 hover:bg-red-100 border-none text-xs font-bold"
                        
                    /> */}
                </div>
            </div>
        </div>
    );
};

export default BundleCard;